import Spinner from "../../../Spinner";
import Card from "../../../Card";
import { POINTS_WON_NAMES } from "../../../../utils/racketStatNames";
import { useQuery } from "@apollo/client";
import { BADMINTON_STATS } from "../../../../api/fixture";
import Avatar from "../../../Avatar";

export default function BoxScore({
  periods,
  fixtureId,
  homePlayer,
  awayPlayer,
}) {
  const { loading, error, data } = useQuery(BADMINTON_STATS, {
    variables: { id: fixtureId },
  });

  if (error) {
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    return <Spinner />;
  }

  const stats = data?.fixture?.stats;
  const participantType = data?.fixture?.event?.participantType;
  const periodsWithScores = periods.map((period) => ({
    ...period,
    homeScore: stats.filter(
      (s) =>
        POINTS_WON_NAMES.includes(s.statType?.name) &&
        s.fixturePeriod?.id === period.id &&
        (participantType === "INDIVIDUAL"
          ? s.profile?.id === homePlayer?.profile?.id
          : s.organization?.id === homePlayer?.organization?.id)
    ).length,
    awayScore: stats.filter(
      (s) =>
        POINTS_WON_NAMES.includes(s.statType?.name) &&
        s.fixturePeriod?.id === period.id &&
        (participantType === "INDIVIDUAL"
          ? s.profile?.id === awayPlayer?.profile?.id
          : s.organization?.id === awayPlayer?.organization?.id)
    ).length,
  }));

  return (
    <Card className="fixture-badminton-stats__box-score">
      <div className="fixture-badminton-stats__box-score__column players">
        <div className="fixture-badminton-stats__box-score__column__label">
          {participantType === "INDIVIDUAL" ? "PLAYER" : "TEAM"}
        </div>
        <div className="fixture-badminton-stats__box-score__column__value">
          <div className="fixture-badminton-stats__box-score__column__value__image">
            {(homePlayer?.profile?.profilePhoto ||
              homePlayer?.organization?.profilePhoto) && (
              <Avatar
                media={
                  homePlayer?.profile?.profilePhoto ||
                  homePlayer?.organization?.profilePhoto
                }
              />
            )}
          </div>
          {homePlayer?.profile?.name || homePlayer?.organization?.name}
        </div>
        <div className="fixture-badminton-stats__box-score__column__value">
          <div className="fixture-badminton-stats__box-score__column__value__image">
            {(awayPlayer?.profile?.profilePhoto ||
              awayPlayer?.organization?.profilePhoto) && (
              <Avatar
                media={
                  awayPlayer?.profile?.profilePhoto ||
                  awayPlayer?.organization?.profilePhoto
                }
              />
            )}
          </div>
          {awayPlayer?.profile?.name || awayPlayer?.organization?.name}
        </div>
      </div>

      {periodsWithScores.map((period) => (
        <div className="fixture-badminton-stats__box-score__column period">
          <div className="fixture-badminton-stats__box-score__column__label">
            {period.label.toUpperCase()}
          </div>
          <div
            className={
              "fixture-badminton-stats__box-score__column__value " +
              (period.homeScore > period.awayScore ? "bold" : "")
            }
          >
            {period.homeScore}
          </div>
          <div
            className={
              "fixture-badminton-stats__box-score__column__value " +
              (period.awayScore > period.homeScore ? "bold" : "")
            }
          >
            {period.awayScore}
          </div>
        </div>
      ))}
    </Card>
  );
}
